import { render, staticRenderFns } from "./OptDialog.vue?vue&type=template&id=02eb783f&scoped=true"
import script from "./OptDialog.vue?vue&type=script&lang=js"
export * from "./OptDialog.vue?vue&type=script&lang=js"
import style0 from "./OptDialog.vue?vue&type=style&index=0&id=02eb783f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02eb783f",
  null
  
)

export default component.exports